import update from "../../redux/update";
import { getAvatarImageUrl, getHeroImageUrl } from "../../helpers/imageHelper";
import PageService from "../../services/pageService";

import { loadingStatus } from "../../constants/loading";
import { defaultDonationAmounts } from "../../constants/recurring";
import { pageStatuses } from "../../constants/pageStatues";

export const ON_VALUE_CHANGE = "page/ON_VALUE_CHANGE";

export const GETTING_PAGE_STARTED = "page/GETTING_PAGE_STARTED";
export const GETTING_PAGE_SUCCESS = "page/GETTING_PAGE_SUCCESS";
export const GETTING_PAGE_FAILED = "page/GETTING_PAGE_FAILED";

export const LOADING_GOOGLE_MAPS_SCRIPT_FINISHED =
  "LOADING_GOOGLE_MAPS_SCRIPT_FINISHED";

interface IPageReducer {
  loadingStatus: number;
  gmapsLoaded: boolean;
  campaign?: any;
  organization?: any;
  primaryPath?: string;
  secondaryPath?: string;
}

const initialState: IPageReducer = {
  loadingStatus: loadingStatus.NOT_STARTED,
  gmapsLoaded: false,
};

const pageReducer = (
  state = initialState,
  action: {
    type: any;
    payload: { path: any; value: any; organization: any; campaign: any };
  }
) => {
  let newState = state;
  switch (action.type) {
    case ON_VALUE_CHANGE:
      // @ts-ignore
      newState = update.set(
        newState,
        action.payload.path,
        action.payload.value
      );
      break;

    case GETTING_PAGE_STARTED:
      newState = {
        ...state,
        loadingStatus: loadingStatus.IS_LOADING,
      };
      break;

    case GETTING_PAGE_SUCCESS: {
      const model = action.payload;

      if (model.campaign) {
        const template = model.campaign?.template?.value;
        const heroImage = template?.heroImagePath;
        const primaryPath = action.payload.organization?.urlPath;
        const secondaryPath = action.payload.campaign?.urlPath;
        const thankYouImageUrl = template?.donationSetup?.thankYouImageUrl;
        const thankYouVideoUrl = template?.donationSetup?.thankYouVideoUrl;
        const selectedMediaType = template?.donationSetup?.selectedMediaType;

        newState = {
          ...state,
          campaign: {
            ...model.campaign,
            heroImageUrl: getHeroImageUrl(heroImage),
            mainImageUrl: getAvatarImageUrl(model.campaign.mainImagePath),
            defaultDonations: template?.donationSetup?.defaultAmounts,
            thankYouMessage: template?.donationSetup?.thankYouMessage,
            thankYouImageUrl: thankYouImageUrl
              ? getHeroImageUrl(thankYouImageUrl, true)
              : null,
            thankYouVideoUrl: thankYouVideoUrl,
            selectedMediaType: selectedMediaType,
            isArchived: model.campaign?.status === pageStatuses.Archived,
          },
          organization: {
            ...model.organization,
            defaultDonations:
              model.organization?.template?.value?.recurringDonationSetup
                ?.defaultAmounts || defaultDonationAmounts,
          },
          primaryPath,
          secondaryPath,
          loadingStatus: loadingStatus.SUCCESS,
        };
      }

      break;
    }

    case GETTING_PAGE_FAILED:
      newState = {
        ...state,
        loadingStatus: loadingStatus.ERROR,
      };
      break;

    case LOADING_GOOGLE_MAPS_SCRIPT_FINISHED: {
      newState = update(newState, {
        gmapsLoaded: { $set: true },
      });
      break;
    }

    default:
      return newState;
  }

  return newState;
};

export const onValueChange = (path: string, value: any) => {
  return {
    type: ON_VALUE_CHANGE,
    payload: {
      path: path,
      value: value,
    },
  };
};

export const loadingGoogleMapsScriptFinished = () => {
  return {
    type: LOADING_GOOGLE_MAPS_SCRIPT_FINISHED,
  };
};

export const getPageActions = {
  start: () => {
    return {
      type: GETTING_PAGE_STARTED,
    };
  },

  success: (data: any) => {
    return {
      type: GETTING_PAGE_SUCCESS,
      payload: { ...data },
    };
  },

  failed: () => {
    return {
      type: GETTING_PAGE_FAILED,
    };
  },
};

export const getPage = (primaryPath: string, secondaryPath: string) => {
  return (dispatch: (arg0: { type: string; payload?: any }) => void) => {
    dispatch(getPageActions.start());

    PageService.get(primaryPath, secondaryPath)
      .then((response) => {
        dispatch(getPageActions.success(response.data.data));
      })
      .catch(() => {});
  };
};

export default pageReducer;
